import { render, staticRenderFns } from "./JcomTableBoardMembersEdit.vue?vue&type=template&id=ebe19182"
import script from "./JcomTableBoardMembersEdit.vue?vue&type=script&lang=js"
export * from "./JcomTableBoardMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./JcomTableBoardMembersEdit.vue?vue&type=style&index=0&id=ebe19182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports